import TaskItem from './TaskItem';

const TaskList = ({ tasks, onDelete, onToggle, onEdit }) => {
    return (
        <div className="task-list">
            {tasks.length > 0 ? (
                tasks.map((task) => (
                    <TaskItem
                        key={task._id}
                        task={task}
                        onDelete={onDelete}
                        onToggle={onToggle}
                        onEdit={onEdit}
                    />
                ))
            ) : (
                <h3>Aucune tâche à afficher</h3>
            )}
        </div>
    );
};

export default TaskList;
